// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Index file for Sisense UI Components predefined events.
 * @author artem.lit@sisense.com (Artem Lytvynov).
 * @copyright Sisense Inc.
 * @licence Sisense License.
 */

const ComponentReady = require('./componentready').ComponentReady;
const ComponentDestroy = require('./componentdestroy').ComponentDestroy;
exports.ComponentReady = ComponentReady;
exports.ComponentDestroy = ComponentDestroy;
